import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getCash(page, perPage) {
        return Axios.get(`${baseURL}billing/cash-reconciliation`, {
            params: { perPage, page }
        }).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    addCash(data) {
        return Axios.post(`${baseURL}billing/cash-reconciliation`, data).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                } else {
                    return null;
                }
            }
        );
    },
    updateCash(data, cashId) {
        return Axios.put(
            `${baseURL}billing/cash-reconciliation/${cashId}`,
            data
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            } else {
                return null;
            }
        });
    },
    deleteCashReconciliation(cashId) {
        return Axios.delete(
            `${baseURL}billing/cash-reconciliation/${cashId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            } else {
                return null;
            }
        });
    }
};
